var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product_headline"},[_c('h4',{staticClass:"text-3xl font-light md:text-5xl"},[_vm._v("\n    "+_vm._s(_vm.item.product_headline)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }